import React from "react";
import { PromptModal } from "@/components/Common/PromptModal";
import { ConfirmationModalProps, useConfirmationModal } from "@/hooks/useConfirmationModal";

export const useSwitchAccountLanguageConfirmationModal = () => {
    const { ConfirmationModal, confirm } = useConfirmationModal<boolean, SwitchAccountLanguageModalProps>(
        SwitchAccountLanguageConfirmationModal,
    );

    return {
        SwitchLanguageConfirmationModal: ConfirmationModal,
        confirmSwitchLanguage: confirm,
    };
};

interface SwitchAccountLanguageModalProps {
    currentLanguage?: string;
    newLanguage?: string;
}

const SwitchAccountLanguageConfirmationModal = ({
    isOpen,
    onClose,
    onContinue,
    currentLanguage,
    newLanguage,
}: ConfirmationModalProps<boolean, SwitchAccountLanguageModalProps>) => {
    return (
        <PromptModal
            title="Warning: You may lose translations"
            isOpen={isOpen}
            dialogText={{ secondary: "Cancel", submit: "Change account language" }}
            onConfirm={onContinue}
            onClose={onClose}
        >
            <div>
                You are attempting to change your account language from {currentLanguage} to {newLanguage}. Any existing{" "}
                {newLanguage} translations you have will be lost if you proceed with this action. The existing{" "}
                {newLanguage} translations will not be copied over into your base account language. Please proceed with
                caution.
            </div>
            <div className="mt-4">Are you sure you want to proceed?</div>
        </PromptModal>
    );
};
